import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";

class RejectedBadgesList extends Component {
    state = {
        delete: false,
        update: false,
        item: {},
        apply: false
    };

    toggleApply = () => {
        this.state.apply === true
            ? this.setState({ apply: false })
            : this.props
                  .getItem(this.props.item.id)
                  .then(response => {
                      this.setState({ apply: true, item: response.data });
                  })
                  .catch(error => {
                      this.context.state.handelError(error);
                  });
    };

    render() {
        return (
            <Fragment>
                <tr>
                    <td>{this.props.item.id}</td>
                    <td>
                        {this.props.item.user.first_name}{" "}
                        {this.props.item.user.last_name}
                    </td>
                    <td>{this.props.item.user.email}</td>
                    <td>
                        <img
                            style={{ width: 32 }}
                            src={this.props.item.user.image}
                            alt={this.props.item.user.name}
                        ></img>
                    </td>
                </tr>
            </Fragment>
        );
    }
}
RejectedBadgesList.contextType = AppContext;
export default RejectedBadgesList;



// WEBPACK FOOTER //
// ./src/components/admin/adminBadges/RejectedBadgesList.js